import React, { useEffect, useState } from 'react'
import { Box, Card, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxPopper from 'components/reusable/AdxPopper'
import FloatActBtn from './floatActBtn'

import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const SectionCard = ({
  handleFloatAddQuestion,
  handleFloatAddSection,
  handleSectDuplicate,
  handleSectDelete,
  handleSectTitle,
  handleSectDesc,
  handleSectMove,
  sectTitle,
  sectDesc,
  sectionName,
  sectionNumber,
  sectionLength,
  sectionColor,
  formType,
  formLoading,
  createError,
  sx,
  ...rest
}) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  const matchesMd = useMediaQuery(theme.breakpoints.up('md'))

  const [sectTitleState, setSectTitleState] = useState(sectTitle)
  const [sectDescState, setSectDescState] = useState(sectDesc)

  useEffect(() => {
    if (sectTitleState !== sectTitle) {
      const sectTitleDelay = setTimeout(() => {
        handleSectTitle(sectionNumber - 1, sectTitleState)
      }, 150)
      return () => clearTimeout(sectTitleDelay)
    }
  }, [sectTitleState])

  useEffect(() => {
    if (sectDescState !== sectDesc) {
      const sectDescDelay = setTimeout(() => {
        handleSectDesc(sectionNumber - 1, sectDescState)
      }, 150)
      return () => clearTimeout(sectDescDelay)
    }
  }, [sectDescState])
  // in-component handling of section and description title state

  return (
    <Box display="flex" flexDirection="row" alignItems="flex-end" position="relative">
      <Card
        sx={{
          width: '100%',
          height: 'auto',
          paddingTop: '16px',
          paddingBottom: '20px',
          boxShadow: '0px 0px 10px lightgray',
          borderRadius: '4.5px',
          ...sx,
        }}
      >
        <Box
          sx={{
            borderBottom: '1px solid',
            borderBottomColor: 'gray-line.main',
            padding: '0px 25px 16px',
          }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {sectionName === 'formHeader' ? (
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              {formType} Form{' '}
            </Typography>
          ) : (
            <Typography variant="h4" color="alternate.main" fontWeight="600">
              Section {sectionNumber ? sectionNumber : null}
            </Typography>
          )}
          {sectionName === 'formHeader' ? null : (
            <AdxPopper>
              <Box onClick={() => handleSectDuplicate(sectionNumber)}>Duplicate section</Box>
              {sectionLength !== 1 ? (
                <Box onClick={() => handleSectDelete(sectionNumber)}>Delete section</Box>
              ) : null}
            </AdxPopper>
          )}
        </Box>
        <Box sx={{ padding: '20px 25px 0px' }} display="flex" flexDirection="column" gap={2}>
          <AdxInput
            label={sectionName === 'formHeader' ? 'Form Title' : 'Title'}
            size="standard"
            value={sectTitleState}
            placeholder={
              sectionName === 'formHeader' ? 'Untitled form' : `Untitled section ${sectionNumber}`
            }
            onChange={(i) => setSectTitleState(i.target.value)}
            isErrorShown={createError ? true : false}
            errorMessage={
              <AdxErrorMessage>
                {sectionName === 'formHeader' ? 'Form title' : 'Section title'} cannot be empty
              </AdxErrorMessage>
            }
          />
          <AdxInput
            label="Description (optional)"
            size="standard"
            value={sectDescState}
            placeholder="Type here..."
            onChange={(i) => setSectDescState(i.target.value)}
            multiline
            sxInput={{ padding: 2 }}
          />
        </Box>
      </Card>
      {matchesMd && sectionName !== 'formHeader' ? (
        <FloatActBtn
          handleFloatAddQuestion={handleFloatAddQuestion}
          handleFloatAddSection={handleFloatAddSection}
          handleSectMove={handleSectMove}
          sectIndex={sectionNumber - 1}
          quesIndex={undefined}
          sectionLength={sectionLength}
          isHeader={sectionName === 'formHeader' ? true : false}
          isSection
        />
      ) : null}
    </Box>
  )
}

export default SectionCard
